import { IonBadge } from "@ionic/react";
import { DataModelV2, VolunteerForUI } from "./data";
import { useInstance } from "@meraki-internal/react-dependency-injection";
import { Image } from "./volunteers/Image";
import { titleHelper } from "./volunteers/VolunteerCard";

export const Volunteer: React.FC<{ volunteer: VolunteerForUI; }> = ({ volunteer }) => {
    const data = useInstance(DataModelV2);

    const firstClub = volunteer.clubIds[0];
    const clubName = firstClub ? data.getClub(firstClub).name : '';

    const splitTitles = titleHelper(volunteer.titles);

    return (
        <div style={{ margin: 10 }}>
            <div className="team-layout-1" style={{ position: 'relative', width: 240 }}>
                <div style={{ position: 'absolute', top: 10, left: 10, zIndex: 100, display: 'flex', flexDirection: 'column', gap: 5}}>
                    {clubName && (
                        <IonBadge>{clubName}</IonBadge>
                    )}
                    {splitTitles.badges.map(badge => (
                        <IonBadge key={badge}>{badge}</IonBadge>
                    ))}
                </div>

                <figure className="team-member">
                    <Image src={volunteer.imagePath} />
                </figure>

                <article className="team-info">
                    <h3 style={{ margin: 0, padding: 0}}>
                        {volunteer.name}
                    </h3>
                    <ul>
                        {splitTitles.titles.map((t, i) => (
                            <li key={i}>
                                {t}
                            </li>
                        ))}
                    </ul>
                </article>
            </div>
        </div>
    );
}
